export const DEFAULT_FORMATTED_TEXT_HTML = '<p></p>';
const ALLOWED_TAGS = new Set([
    'P',
    'H1',
    'H2',
    'H3',
    'DIV',
    'SPAN',
    'B',
    'STRONG',
    'I',
    'EM',
    'U',
    'BR',
]);
const ALLOWED_STYLES = new Set([
    'color',
    'background-color',
    'font-size',
    'line-height',
    'margin-bottom',
    'margin-top',
]);
const styleToMap = (styleValue) => {
    const map = new Map();
    styleValue.split(';').forEach((part) => {
        const [rawKey, rawValue] = part.split(':');
        const key = rawKey?.trim().toLowerCase();
        const value = rawValue?.trim();
        if (!key || !value || !ALLOWED_STYLES.has(key))
            return;
        map.set(key, value);
    });
    return map;
};
const mapToStyle = (styleMap) => ([...styleMap.entries()].map(([k, v]) => `${k}:${v}`).join(';'));
export const isFormattedText = (value) => {
    if (!value || typeof value !== 'object')
        return false;
    const candidate = value;
    return candidate.type === 'FormattedText' && typeof candidate.html === 'string';
};
export const getFormattedTextHtml = (value) => {
    if (typeof value === 'string')
        return value;
    if (isFormattedText(value))
        return value.html;
    return '';
};
export const getFormattedTextPlain = (value) => {
    const html = getFormattedTextHtml(value);
    if (!html)
        return '';
    if (typeof window !== 'undefined' && typeof DOMParser !== 'undefined') {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
    }
    return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
};
export const sanitizeFormattedTextHtml = (rawHtml) => {
    if (!rawHtml)
        return '';
    if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
        return rawHtml
            .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
            .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '')
            .replace(/\son\w+="[^"]*"/gi, '');
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(rawHtml, 'text/html');
    const nodes = [...doc.body.querySelectorAll('*')];
    nodes.forEach((node) => {
        if (!ALLOWED_TAGS.has(node.tagName)) {
            const text = doc.createTextNode(node.textContent || '');
            node.parentNode?.replaceChild(text, node);
            return;
        }
        [...node.attributes].forEach((attr) => {
            const attrName = attr.name.toLowerCase();
            if (attrName.startsWith('on')) {
                node.removeAttribute(attr.name);
                return;
            }
            if (attrName === 'style') {
                const styleMap = styleToMap(attr.value);
                const nextStyle = mapToStyle(styleMap);
                if (!nextStyle) {
                    node.removeAttribute('style');
                }
                else {
                    node.setAttribute('style', nextStyle);
                }
                return;
            }
            if (attrName !== 'data-formatted-text') {
                node.removeAttribute(attr.name);
            }
        });
    });
    return doc.body.innerHTML;
};
//# sourceMappingURL=formattedText.js.map